
import { RootState } from "../store";
import { createSelector } from "@reduxjs/toolkit";


const selectRecruitment = (state: RootState) => state.recruitment;


export const selectJobs = createSelector(
  [selectRecruitment],
  (r) => r.jobs,
);
export const selectJobsLoading = createSelector(
  [selectRecruitment],
  (r) => r.jobsLoading,
);
export const selectJobsPagination = createSelector(
  [selectRecruitment],
  (r) => r.jobsPagination,
);
export const selectActiveJob = createSelector(
  [selectRecruitment],
  (r) => r.activeJob,
);
export const selectActiveJobLoading = createSelector(
  [selectRecruitment],
  (r) => r.activeJobLoading,
);
export const selectJobFilters = createSelector(
  [selectRecruitment],
  (r) => r.jobFilters,
);


export const selectApplications = createSelector(
  [selectRecruitment],
  (r) => r.applications,
);
export const selectApplicationsLoading = createSelector(
  [selectRecruitment],
  (r) => r.applicationsLoading,
);
export const selectApplicationsPagination = createSelector(
  [selectRecruitment],
  (r) => r.applicationsPagination,
);
export const selectActiveApplication = createSelector(
  [selectRecruitment],
  (r) => r.activeApplication,
);
export const selectActiveApplicationLoading = createSelector(
  [selectRecruitment],
  (r) => r.activeApplicationLoading,
);
export const selectApplicationFilters = createSelector(
  [selectRecruitment],
  (r) => r.applicationFilters,
);


export const selectInterviews = createSelector(
  [selectRecruitment],
  (r) => r.interviews,
);
export const selectInterviewsLoading = createSelector(
  [selectRecruitment],
  (r) => r.interviewsLoading,
);
export const selectPendingFeedbacks = createSelector(
  [selectRecruitment],
  (r) => r.pendingFeedbacks,
);


export const selectReferrals = createSelector(
  [selectRecruitment],
  (r) => r.referrals,
);
export const selectReferralsLoading = createSelector(
  [selectRecruitment],
  (r) => r.referralsLoading,
);
export const selectReferralStats = createSelector(
  [selectRecruitment],
  (r) => r.referralStats,
);
export const selectTopReferrers = createSelector(
  [selectRecruitment],
  (r) => r.topReferrers,
);


export const selectRecruitmentError = createSelector(
  [selectRecruitment],
  (r) => r.error,
);
export const selectActiveCompany = createSelector(
  [selectRecruitment],
  (r) => r.activeCompany,
);


export const selectCareerPageSettings = createSelector(
  [selectRecruitment],
  (r) => r.careerPageSettings,
);
export const selectCareerPageSettingsLoading = createSelector(
  [selectRecruitment],
  (r) => r.careerPageSettingsLoading,
);
export const selectCareerPageLink = createSelector(
  [selectRecruitment],
  (r) => r.careerPageLink,
);
export const selectCareerPageLinkLoading = createSelector(
  [selectRecruitment],
  (r) => r.careerPageLinkLoading,
);
export const selectIntegrations = createSelector(
  [selectRecruitment],
  (r) => r.integrations,
);
export const selectIntegrationsLoading = createSelector(
  [selectRecruitment],
  (r) => r.integrationsLoading,
);
export const selectATSScoringWeights = createSelector(
  [selectRecruitment],
  (r) => r.atsScoringWeights,
);
export const selectATSScoringWeightsLoading = createSelector(
  [selectRecruitment],
  (r) => r.atsScoringWeightsLoading,
);

export const selectRoundTemplates = createSelector(
  [selectRecruitment],
  (r) => r.roundTemplates,
);
export const selectRoundTemplatesLoading = createSelector(
  [selectRecruitment],
  (r) => r.roundTemplatesLoading,
);
export const selectJobRounds = createSelector(
  [selectRecruitment],
  (r) => r.jobRounds,
);
export const selectJobRoundsLoading = createSelector(
  [selectRecruitment],
  (r) => r.jobRoundsLoading,
);
export const selectAvailableInterviewers = createSelector(
  [selectRecruitment],
  (r) => r.availableInterviewers,
);
export const selectAvailableInterviewersLoading = createSelector(
  [selectRecruitment],
  (r) => r.availableInterviewersLoading,
);

// Application Rounds (Pipeline)
export const selectApplicationRounds = createSelector(
  [selectRecruitment],
  (r) => r.applicationRounds,
);
export const selectApplicationRoundsLoading = createSelector(
  [selectRecruitment],
  (r) => r.applicationRoundsLoading,
);
